import React from 'react';
import classes from './ContentPage.module.scss';
import Image from 'next/image';
import Link from 'next/link';
import { parseContent, renderContentWithPopoutIcon } from '@/utils/utils.js';

const ContentPage = ({ additionalClasses, element, ...props }) => {
  const t = props.t;

  return (
    <div className={additionalClasses}>
      {element?.map((content, index) => {
        return (
          <React.Fragment key={index}>
            {content?.logo && (
              <p>
                {content?.logo?.link?.href && (
                  <Link href={content?.logo?.link?.href} target={content?.logo?.link?.target || '_self'}>
                    <Image
                      src={content?.logo?.url}
                      width={content?.logo?.size?.width}
                      height={content?.logo?.size?.height}
                      alt={content?.logo?.alt}
                    />
                  </Link>
                )}
                {!content?.logo?.link?.href && (
                  <Image src={content?.logo?.url} width={content?.logo?.size?.width} height={content?.logo?.size?.height} alt={content?.logo?.alt} />
                )}
              </p>
            )}
            {content?.text && (
              <p
                className={classes.contentText}
                dangerouslySetInnerHTML={{ __html: parseContent(t(content?.text), renderContentWithPopoutIcon()) }}
              ></p>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default ContentPage;
